import { Type } from "class-transformer";
import { IsString } from "class-validator";
import { IsArrayOfInstancesOf } from "../../../class-validator/class-validator-constraints";
import { FamilyStepOptionDto } from "./family-step-option.dto";

export class FamilyStepDto {
  @IsArrayOfInstancesOf(FamilyStepOptionDto)
  @Type(() => FamilyStepOptionDto)
  options!: FamilyStepOptionDto[];

  @IsString()
  stepSelectionType!: string;
}
